import {
  addDisplayName,
  addHandlers,
  addProps,
  addState,
  flowMax,
} from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addApi } from 'shared/src/api'

import { BODY_MEDIUM_STYLE } from './styles'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'

const useStyles = createUseStyles({
  button: {
    ...BODY_MEDIUM_STYLE,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    paddingLeft: 16,
    paddingRight: 16,
    height: 64,
    backgroundColor: 'rgba(54, 52, 50, 0.8)',
    color: 'white',
    '&:disabled': {
      opacity: 0.5,
    },
  },
})

interface Props {
  tagId: number
  creatorId: number
  mediaId: number
}

export const TagNotificationButton: FC<Props> = flowMax(
  addDisplayName('TagNotificationButton'),
  addApi,
  addState('isNotifying', 'setIsNotifying', false),
  addTranslationHelpers,
  addHandlers({
    onNotify:
      ({ setIsNotifying, api, tagId, creatorId, mediaId, t }) =>
      async () => {
        setIsNotifying(true)
        try {
          await api.messages.create({
            recipient: { userId: creatorId },
            content: { taggedMedia: { tagId, mediaId } },
            imageId: null,
          })
          alert(t('admin.messages.successMessage'))
        } catch (error) {
          alert(t('admin.messages.errorMessage'))
        }

        setIsNotifying(false)
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ onNotify, isNotifying, classes, t }) => (
    <button
      onClick={onNotify}
      disabled={isNotifying}
      className={classes.button}
    >
      {t('admin.resources.media.notifyTagged')}
    </button>
  )
)
